import React from 'react';
import { Link } from 'react-router-dom';
import ListCodes from '../ListCodes/ListCodes';
import { useAuth } from '../../contexts/AuthContext';
import NavigationBar from '../NavigationBar/NavigationBar';
import Footer from '../Footer/Footer';
import './KeysPage.css'; // We'll create this file

const KeysPage = () => {
  const { state } = useAuth();
  
  if (!state.isLoggedIn) {
    return (
      <>
        <NavigationBar />
        <div className="container">
          <div className="text-center p-5">
            <h2>Please log in to view your keys</h2>
            <div className="mt-4">
              <Link to="/login" className="btn btn-primary">Log in</Link>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <NavigationBar />
      <div className="container keys-container">
        <div className="keys-header">
          <h1 className="text-center">Your Encryption Keys</h1>
        </div>
        
        <div className="row justify-content-center">
          <div className="col-md-10">
            
            <div className="keys-card">
              <ListCodes />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default KeysPage;
